/* istanbul ignore file */
import Messaging from './Messaging';

export { default as MessagingProvider } from './MessagingProvider';

export default Messaging;
